import React, { FC } from 'react';

import Modal from '~components/atoms/Modal';
import ProductSettingCreateProductForm from '../ProductSettingCreateProductForm';
import { useAppSelector } from '~redux/hooks';
import { useDispatch } from 'react-redux';
import combinedActions from '~redux/combinedActions';

const ProductSettingCreateProductModal = () => {
    const dispatch = useDispatch();

    const isOpen = useAppSelector(state => state.setting.modals.productSettingCreateProductModalIsOpen);

    const onClose = () => {
        dispatch(combinedActions.settingSetProductSettingCreateProductModalIsOpen(false));
    };

    return (
        <Modal
            title='Create Product'
            isOpen={isOpen}
            onClose={onClose}
        >
            <ProductSettingCreateProductForm />
        </Modal>
    );
};

export default ProductSettingCreateProductModal;
